import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';

import { CornerstoneService } from '@viewer/cornerstone.service';
import {
  HotKey,
  HotKeySettings,
  ResetViewsToolComponentKeyActionName,
  ResetViewsToolComponentKeyActionNameList,
} from '@viewer/data';
import { KeyInteractionService } from 'src/app/interaction';
import { OCCViewerService } from '@viewer/occ-viewer/occ-viewer.service';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { TriggerAction } from '@shared/actions';

@Component({
  selector: 'app-reset-views-tool',
  templateUrl: 'reset-views-tool.component.html',
  styleUrls: ['reset-views-tool.component.scss'],
})
export class ResetViewsToolComponent implements OnInit, OnDestroy {
  @Input() useHotKeys = true;

  public resetViewsAction!: TriggerAction;

  private _unsubscribe$ = new Subject<void>();

  constructor(
    private _stateManagerProjectService: StateManagerProjectService,
    private _cornerstoneService: CornerstoneService,
    private _occViewerService: OCCViewerService,
    private _keyInteractionService: KeyInteractionService
  ) {}

  ngOnInit(): void {
    this.resetViewsAction = new TriggerAction(
      'reset-views',
      'Reset Views',
      this._onResetViewsBtnClick.bind(this)
    );

    if (this.useHotKeys) {
      this._initializeHotKeys();
    }

    this.resetViewsAction.isEnable = () =>
      this._stateManagerProjectService.isViewerLoaded$;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();

    if (this.useHotKeys) {
      this._keyInteractionService.removeKeySettingsList([
        ...ResetViewsToolComponentKeyActionNameList,
      ]);
    }
  }

  resetViews(): void {
    this._stateManagerProjectService.viewMode = 4;
    this._cornerstoneService.resetAllViews();
    this._occViewerService.resetView();
  }

  private _onResetViewsBtnClick(): void {
    this.resetViews();
  }

  private _initializeHotKeys(): void {
    this._keyInteractionService
      .initializeHotKey(
        HotKey.V,
        new HotKeySettings<ResetViewsToolComponentKeyActionName>({
          keyActionName: 'ResetViewsTrigger',
        })
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this.resetViews();
      });
  }
}
